<div class="modal-header">
    <h4>Contact List</h4>
</div>
<div class="modal-body">
    <div class="card row" style="display:block;">
        <div style="overflow-x: auto;">
            <div>
                <table class="table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Contact Info</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of signOffList; let i = index ">
                            <td>{{data.FirstName}} {{data.LastName}}<span *ngIf="data.Title != null"><br />{{data.Title}}</span></td>
                            <td>
                                <span><a *ngIf="data.Phone != null" id="phone{{i}}" style="color: #217cbb" href="tel:{{data.Phone}}">Office: {{data.Phone}}</a></span>
                                <span style="display: block;"><a *ngIf="data.Cell != null" id="cell{{i}}" style="color: #217cbb" href="tel:{{data.Cell}}">Cell: {{data.Cell}}</a></span>
                                <span *ngIf="data.Email != null"><a id="email{{i}}" href="mailto:{{data.Email}}">{{data.Email}}</a></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-text-primary" (click)="closeModal()">Close</button>
</div>